// Configuración de datos mock para validaciones
export const MOCK_CONFIG = {
  enabled: false, // Se carga dinámicamente desde config.json
  showIndicators: true,
  logFallback: true,
  version: '1.0.0',
  lastUpdated: '2026-01-22'
};

// Función para cargar configuración desde config.json
let appConfig = null;
const loadAppConfig = async () => {
  if (appConfig) return appConfig;

  try {
    const response = await fetch(`${process.env.PUBLIC_URL}/config.json`);
    appConfig = await response.json();
    MOCK_CONFIG.enabled = appConfig?.features?.enableMockData || false;
    MOCK_CONFIG.showIndicators = appConfig?.features?.showMockIndicators || true;
    MOCK_CONFIG.logFallback = appConfig?.features?.logFallback || true;
  } catch (error) {
    console.warn('Error cargando configuración de mock:', error);
  }

  return appConfig;
};

// Inicializar configuración al cargar el módulo
loadAppConfig();

// Datos mock de validaciones con nueva estructura
export const mockValidations = [
  {
    id: 1,
    name: 'Validación Campo Requerido',
    description: 'Verifica que el campo NOMBRE_PREDIO sea obligatorio',
    type: 'syntactic',
    operator: 'required',
    featureName: 'PREDIOS',
    fieldName: 'NOMBRE_PREDIO',
    value: null,
    featureNameRelated: null,
    fieldNameRelated: null,
    subtype: null,
    domain: null,
    errorMessage: 'La validación {validation_name} del feature {feature_name} en el campo {field_name} falló: campo requerido vacío',
    successMessage: 'La validación {validation_name} del feature {feature_name} en el campo {field_name} fue exitosa',
    templateId: 1,
    templateName: 'Plantilla Catastral',
    severity: 'error',
    isActive: true,
    createdAt: '2026-01-22T10:00:00Z',
    createdBy: 'admin',
    lastModifiedAt: '2026-01-22T10:00:00Z',
    lastModifiedBy: null
  },
  {
    id: 2,
    name: 'Validación Longitud Máxima',
    description: 'Verifica que el campo NOMBRE_PREDIO no exceda 100 caracteres',
    type: 'syntactic',
    operator: 'max_length',
    featureName: 'PREDIOS',
    fieldName: 'NOMBRE_PREDIO',
    value: '100',
    featureNameRelated: null,
    fieldNameRelated: null,
    subtype: null,
    domain: null,
    errorMessage: 'La validación {validation_name} del feature {feature_name} en el campo {field_name} falló: longitud máxima excedida',
    successMessage: 'La validación {validation_name} del feature {feature_name} en el campo {field_name} fue exitosa',
    templateId: 1,
    templateName: 'Plantilla Catastral',
    severity: 'warning',
    isActive: true,
    createdAt: '2026-01-22T10:15:00Z',
    createdBy: 'admin',
    lastModifiedAt: '2026-01-22T10:15:00Z',
    lastModifiedBy: null
  },
  {
    id: 3,
    name: 'Validación Tipo de Dato',
    description: 'Verifica que el campo AREA sea numérico',
    type: 'syntactic',
    operator: 'data_type',
    featureName: 'PREDIOS',
    fieldName: 'AREA',
    value: 'numeric',
    featureNameRelated: null,
    fieldNameRelated: null,
    subtype: null,
    domain: null,
    errorMessage: 'La validación {validation_name} del feature {feature_name} en el campo {field_name} falló: tipo de dato incorrecto',
    successMessage: 'La validación {validation_name} del feature {feature_name} en el campo {field_name} fue exitosa',
    templateId: 1,
    templateName: 'Plantilla Catastral',
    severity: 'error',
    isActive: true,
    createdAt: '2026-01-22T10:30:00Z',
    createdBy: 'admin',
    lastModifiedAt: '2026-01-22T10:30:00Z',
    lastModifiedBy: null
  },
  {
    id: 4,
    name: 'Validación en Dominio',
    description: 'Verifica que el campo ESTADO_VIAL esté en el dominio correspondiente',
    type: 'domain',
    operator: 'in_domain',
    featureName: 'VIAS',
    fieldName: 'ESTADO_VIAL',
    value: null,
    featureNameRelated: null,
    fieldNameRelated: null,
    subtype: null,
    domain: 'cdom_estado_vial',
    errorMessage: 'La validación {validation_name} del feature {feature_name} en el campo {field_name} falló: valor no está en dominio',
    successMessage: 'La validación {validation_name} del feature {feature_name} en el campo {field_name} fue exitosa',
    templateId: 2,
    templateName: 'Plantilla Vial',
    severity: 'error',
    isActive: true,
    createdAt: '2026-01-22T10:45:00Z',
    createdBy: 'admin',
    lastModifiedAt: '2026-01-22T10:45:00Z',
    lastModifiedBy: null
  },
  {
    id: 5,
    name: 'Validación Relacional FK',
    description: 'Verifica que el ID_MUNICIPIO exista en la tabla MUNICIPIOS',
    type: 'relational',
    operator: 'foreign_key',
    featureName: 'PREDIOS',
    fieldName: 'ID_MUNICIPIO',
    value: null,
    featureNameRelated: 'MUNICIPIOS',
    fieldNameRelated: 'ID',
    subtype: null,
    domain: null,
    errorMessage: 'La validación {validation_name} del feature {feature_name} en el campo {field_name} falló: clave foránea no existe',
    successMessage: 'La validación {validation_name} del feature {feature_name} en el campo {field_name} fue exitosa',
    templateId: 1,
    templateName: 'Plantilla Catastral',
    severity: 'error',
    isActive: true,
    createdAt: '2026-01-22T11:00:00Z',
    createdBy: 'admin',
    lastModifiedAt: '2026-01-22T11:00:00Z',
    lastModifiedBy: null
  },
  {
    id: 6,
    name: 'Validación Topológica - No Overlap',
    description: 'Verifica que los polígonos de PREDIOS no se superpongan',
    type: 'topological',
    operator: 'must_not_overlap',
    featureName: 'PREDIOS',
    fieldName: null,
    value: null,
    featureNameRelated: null,
    fieldNameRelated: null,
    subtype: null,
    domain: null,
    errorMessage: 'La validación {validation_name} del feature {feature_name} falló: geometrías se superponen',
    successMessage: 'La validación {validation_name} del feature {feature_name} fue exitosa',
    templateId: 1,
    templateName: 'Plantilla Catastral',
    severity: 'error',
    isActive: true,
    createdAt: '2026-01-22T11:15:00Z',
    createdBy: 'admin',
    lastModifiedAt: '2026-01-22T11:15:00Z',
    lastModifiedBy: null
  },
  {
    id: 7,
    name: 'Validación Estructural - Feature Required',
    description: 'Verifica que la tabla PREDIOS tenga datos',
    type: 'structure',
    operator: 'feature_required',
    featureName: 'PREDIOS',
    fieldName: null,
    value: null,
    featureNameRelated: null,
    fieldNameRelated: null,
    subtype: null,
    domain: null,
    errorMessage: 'La validación {validation_name} del feature {feature_name} falló: feature sin datos',
    successMessage: 'La validación {validation_name} del feature {feature_name} fue exitosa',
    templateId: 1,
    templateName: 'Plantilla Catastral',
    severity: 'error',
    isActive: true,
    createdAt: '2026-01-22T11:30:00Z',
    createdBy: 'admin',
    lastModifiedAt: '2026-01-22T11:30:00Z',
    lastModifiedBy: null
  }
];

// Función helper para verificar si estamos usando datos mock
export const isUsingMockData = (data) => {
  if (!Array.isArray(data)) return false;
  return data.some(item => item.id && mockValidations.some(mock => mock.id === item.id));
};

// Función helper para agregar metadata de mock a los datos
export const addMockMetadata = (data) => {
  return data.map(item => ({
    ...item,
    _isMockData: true,
    _mockVersion: MOCK_CONFIG.version,
    _lastUpdated: MOCK_CONFIG.lastUpdated
  }));
};

// Función para actualizar configuración de mock
export const updateMockConfig = (newConfig) => {
  Object.assign(MOCK_CONFIG, newConfig);
};

// Función para inicializar configuración
export const initializeMockConfig = loadAppConfig;